import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { getFormFields, isFormValid, isFieldValid } from '../../../../utile/formHelper';
import InputTextB from './../../../customComponents/inputTextB';
import { FIELDS_INFO } from '../../../../constants';
import { trimObj } from '../../../../utile';
import { onTextChange } from '../../../../utile/formHelper';
import { baseUrlAdmin } from '../../../../store/apiConstants';
import LoadingComponent from '../../../loadingComponent';
import { Toast } from 'primereact/toast';
import FileUploadLambda from '../../../fileUpload/fileUploadLambda';
import { getImageUrl } from '../../../../store/actions';

const formFields = [
    {
        "Type": "Text",
        "Label": "Name",
        "FieldName": "name",
        "Required": true,
        "MaxLength": 50
    },
    {
        "Type": "Text",
        "Label": "Content",
        "FieldName": "description",
        "Required": true
    },
    {
        "Type": "Text",
        "Label": "Attachment",
        "FieldName": "attachment",
        "Required": false
    }
]

const imagesBucket = process.env.REACT_APP_IMAGES_BUCKET || 'classetimage-old';

class AddTemplate extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(formFields, this.props.editTemplate || {});
        this.state = {
            template: this.formFields.data,
            formValidations: this.formFields.formValidations,
            isLoading: false
        }
        this.service = new Service();
    }

    footer = () => {
        return (<div>
            <Button label="Cancel" className='p-button-outlined' onClick={this.onCloseDialog} />
            <Button label={`${this.props.editTemplate ? 'Update' : 'Add'}`} className='p-button-raised' onClick={this.onSubmitClick} />
        </div>)
    }

    onSubmitClick = () => {
        let { template } = this.state;
        let _template = trimObj(template);
        const formStatus = isFormValid(formFields, this.formFields.formValidations, _template);

        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
            });
        } else {
            _template.orgId = this.props.orgId;

            let url = `${baseUrlAdmin}/pushnotificationtemplate`;
            this.setState({
                isLoading: true
            });
            this.service[_template._id ? 'put' : 'post'](url, _template, true).then(res => {

                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false,
                        template: {
                            name: '',
                            description: '',
                            attachment: '',
                            attachmentFileName: ''
                        }
                    }, () => {
                        this.props.onCreateOrEditSuccess(_template._id ? true : false)
                    });

                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }

            }).catch(e => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
                console.log(e);
            })
        }
    };

    onCloseDialog = () => {
        this.props.hideAddTemplateDialog();
    }

    // Attachment functionality from notifications.js
    _afterFilesUploaded = (files) => {

    }

    _onAttachSuccess = (fieldName) => (fileName, data) => {
        this.props.getImageUrl(data.imageStorageKey);
        this.addAttachment(fieldName, fileName, data);
    }

    addAttachment = (fieldName, fileName, data) => {
        let template = {
            ...this.state.template,
            [fieldName]: data.imageStorageKey,
            [fieldName + 'FileName']: fileName
        }

        let formValidations = isFieldValid(formFields.find(fm => fm.FieldName == fieldName), this.state.formValidations, template);

        this.setState((prevState) => {
            return {
                template,
                formValidations
            }
        });

        // Show success message
        this.toast?.show({
            severity: 'success',
            summary: 'Success',
            detail: `File "${fileName}" uploaded successfully`,
            life: 3000
        });
    }

    removeAttach = (fieldName) => {
        this.setState((prevState) => {
            return {
                template: {
                    ...prevState.template,
                    [fieldName]: '',
                    [fieldName + 'FileName']: ''
                }
            };
        });
    }

    _onProgress = (progress) => {
        // Handle progress if needed
    }

    _onFilsUploadError = (error) => {
        this.toast?.show({
            severity: 'error',
            summary: 'Error',
            detail: 'File upload failed',
            life: 3000
        });
    }

    // Add a helper function to check if file is an image
    isImageFile = (fileName) => {
        if (!fileName) return false;
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        const lowerFileName = fileName.toLowerCase();
        return imageExtensions.some(ext => lowerFileName.endsWith(ext));
    }

    render() {
        const { template, formValidations } = this.state;

        return (
            <Dialog header={`${this.props.editTemplate ? 'Edit' : 'Add'} Template`} headerClassName='text-center'
                blockScroll={true}
                draggable={false}
                footer={this.footer}
                closeOnEscape={true}
                dismissableMask={true}
                visible={true}
                style={{
                    width: '60%',
                }}
                closable={false}
                onHide={() => this.setState({ showCreateDialog: false })}>
                <div className="grid subject-add-dialog">
                    <div className="col-4 p-md-4 p-lg-4">
                        <p className='text-label'>Name<span className='ma-required'>*</span></p>
                    </div>
                    <div className="col-8 p-md-8 p-lg-8 ma-mt2">
                        <InputTextB info={FIELDS_INFO.TEMPLATE_NAME} id="topicn">
                            <InputText value={template.name}
                                placeholder='Enter notification template name'
                                onChange={(e) => {
                                    onTextChange(e.target.value, 'name', this, formFields, template, formValidations, 'template', 'formValidations')
                                }} className='w-10 p-inputtext-style1 ma-w100p' />
                        </InputTextB>
                        {formValidations && !formValidations.fields['name'].isValid && <p className="p-error">{formValidations.fields['name'].errorMsg}</p>}
                    </div>
                </div>
                <div className="grid subject-add-dialog">
                    <div className="col-4 p-md-4 p-lg-4">
                        <p className='text-label' >Description<span className='ma-required'>*</span></p>
                    </div>
                    <div className="col-8 p-md-8 p-lg-8 ma-mt2">
                        <InputTextB info={FIELDS_INFO.NOTIFICATION_DESCRIPTION} id="topicn">
                            <InputTextarea value={template.description}
                                placeholder='Enter notification description'
                                rows={6}
                                onChange={(e) => {
                                    onTextChange(e.target.value, 'description', this, formFields, template, formValidations, 'template', 'formValidations')
                                }} className='w-10 p-inputtext-style1 ma-w100p ' />
                        </InputTextB>
                        {formValidations && !formValidations.fields['description'].isValid && <p className="p-error">{formValidations.fields['description'].errorMsg}</p>}
                    </div>
                </div>
                {/* <div className="grid subject-add-dialog">
                    <div className="col-4 p-md-4 p-lg-4">
                        <p className='text-label'>Attachment</p>
                    </div>
                    <div className="col-8 p-md-8 p-lg-8 ma-mt2">
                        <FileUploadLambda id={'pushnotificationtemplate_att'}
                            multiple={false}
                            onProgress={this._onProgress}
                            onSucess={(fileName, data) => this._onAttachSuccess('attachment')(fileName, data)}
                            maxFileSize={5120000}
                            onError={this._onFilsUploadError}
                            accept={'images'}
                            title={'Push Notification Attachments'}
                            dirName=''
                            afterFilesUploaded={this._afterFilesUploaded}
                        >
                            <label className='ma-label-s2 font-serif font-semibold text-900 text-lg' htmlFor={'pushnotificationtemplate_att'}>
                                Attachment <i className='pi pi-file' />
                            </label>
                        </FileUploadLambda>

                        {template['attachment'] && (
                            <div className="mt-2 p-2 border-1 surface-border border-round">
                                <div className="flex align-items-center justify-content-between">
                                    <span className="text-sm">
                                        {template['attachmentFileName'] || 'Attached file'}
                                    </span>
                                    <Button
                                        icon="pi pi-times"
                                        className="p-button-text p-button-danger p-button-sm"
                                        onClick={() => this.removeAttach('attachment')}
                                        tooltip="Remove attachment"
                                    />
                                </div>
                                {this.isImageFile(template['attachmentFileName']) && (
                                    <img
                                        src={`https://${imagesBucket}.s3.ap-south-1.amazonaws.com/${template['attachment']}`}
                                        alt="Attachment preview"
                                        className='question-img mt-2'
                                        style={{ maxWidth: '200px', maxHeight: '150px' }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div> */}
                {
                    this.state.isLoading && <LoadingComponent />
                }
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </Dialog >
        )
    }
}

const mapStateToProps = (state) => ({
    getAllImagesUrlInfo: (state.getImageUrlInfo && state.getImageUrlInfo.allImageUrls) ? state.getImageUrlInfo.allImageUrls : {},
});

const mapDispatchToProps = (dispatch) => ({
    getImageUrl: (url) => dispatch(getImageUrl(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTemplate);
